import {
    useState,
    forwardRef,
    useImperativeHandle,
    useRef,
} from "react"
import DateSelector from "../DateSelector"
import TextInput from "../TextInput"

// for first name or last name
const nameValidator = (val) => /^[\p{L} '-]{2,50}$/u.test(val.trim())
const licenseNumberValidator = (val) => /^(?=(?:.*[A-Za-z0-9]){3,}).*$/.test(val.trim())

const DriverLicenseInput = forwardRef(({ title, data, readOnly }, ref) => {
    const [error, setError] = useState(false)

    const licenseNumberRef = useRef()
    const issuingCountryRef = useRef()
    const issueDateRef = useRef()
    const expiryDateRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const licenseNumberData = licenseNumberRef.current.validateAndGetData()
            const issuingCountryData = issuingCountryRef.current.validateAndGetData()
            const issueDateData = issueDateRef.current.validateAndGetData()
            const expiryDateData = expiryDateRef.current.validateAndGetData()

            // Combine validity of main name fields
            let validity =
                licenseNumberData.isValid &&
                issuingCountryData.isValid &&
                issueDateData.isValid &&
                expiryDateData.isValid

            const value = {
                licenseNumber: licenseNumberData.value,
                issuingCountry: issuingCountryData.value,
                issueDate: issueDateData.value,
                expiryDate: expiryDateData.value,
            }

            setError(!validity)
            return { isValid: validity, value }
        },
    }))

    return (
        <div className="my-4">
            <label className="block text-sm font-medium text-gray-700 mb-4">{title}</label>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <TextInput
                    title="License Number"
                    ref={licenseNumberRef}
                    data={data?.licenseNumber}
                    validator={licenseNumberValidator}
                    isMandatory={true}
                    disabled={readOnly}
                />

                <TextInput
                    title="Issuing State/Province/Territory/Country"
                    ref={issuingCountryRef}
                    data={data?.issuingCountry}
                    validator={nameValidator}
                    isMandatory={true}
                    disabled={readOnly}
                />

                <DateSelector
                    title="Issue Date"
                    ref={issueDateRef}
                    data={data?.issueDate}
                    readOnly={readOnly}
                />

                <DateSelector
                    title="Expiry Date"
                    ref={expiryDateRef}
                    data={data?.expiryDate}
                    readOnly={readOnly}
                />

            </div>

            {/* Error Message */}
            {error && (
                <p className="mt-2 text-sm text-red-600">
                </p>
            )}
        </div>
    )
})

export default DriverLicenseInput
